import { CheckoutState } from '../state';
import {
    areAsyncExpressCheckoutEligibleCommonRulesMet,
    areSyncExpressCheckoutEligibleCommonRulesMet,
    isPaypalAvailableAsPaymentMethod,
} from './expressCheckout';

export const areSyncExpressPaypalEligibleRulesMet = (state: CheckoutState) =>
    areSyncExpressCheckoutEligibleCommonRulesMet(state);

export const areAsyncExpressPaypalEligibleRulesMet = (state: CheckoutState) =>
    areAsyncExpressCheckoutEligibleCommonRulesMet(state) &&
    isPaypalAvailableAsPaymentMethod(state);
// && !hasExpressCheckoutAsyncErrors(state); // TODO: EB-211790 handle Paypal errors

export const isExpressPaypalEnabled = (state: CheckoutState) =>
    areSyncExpressPaypalEligibleRulesMet(state) &&
    areAsyncExpressPaypalEligibleRulesMet(state);

export const getPaypalScriptStatus = (state: CheckoutState) => {
    return state.paypal.scriptStatus;
};

export const isLoadingPaypal = (state: CheckoutState) =>
    state.paypal.isLoadingPaypal;
